var inBrowser = typeof window !== 'undefined'
class DataLayer {
  constructor (options = {}) {
    this.options = options
    this.logDebug('loaded:', options)
  }
  logDebug () {
    if (this.options.debug) {
      console.log('DataLayer:', ...arguments)
    }
  }
  push (data) {
    if (inBrowser) {
      this.logDebug('push:', data)
      const dataLayer = (window.dataLayer = window.dataLayer || [])
      dataLayer.push(data)
    }
  }
}
export default {
  install (Vue, options) {
    Vue.prototype.$dataLayer = new DataLayer(options)
  }
}